module.exports = __webpack_public_path__ + "public/files/img/sada.4a6c9d77.png";